// Port of api/fuel/app/classes/insights/game/streaks.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'streaks',
    priority: 1,
    requires: ['init'],
    insight: false,
    detail: ['streaks'],
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.has_plays) return {}

        // Reuse pre-computed streak data from Plays segment if available
        if (this._data.computed_streaks) {
            return this._data.computed_streaks
        }

        // Fallback: compute from scratch
        var playsRaw = this._data.plays_raw
        var now = Util.time()

        var playMonths = {}

        for (var i = 0; i < playsRaw.length; i++) {
            var date = parseInt(playsRaw[i].play_date, 10) || 0
            if (date > 0) {
                playMonths[Util.date('Y-m', date)] = true
            }
        }

        if (!Object.keys(playMonths).length) return {}

        var monthNames = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

        var pmKeys = Object.keys(playMonths).sort()
        var firstMonth = pmKeys[0]
        var nowMonth = Util.date('Y-m', now)

        var cursor = firstMonth
        var streaks = []
        var streakStart = firstMonth
        var streakLen = 0
        var streakType = null

        while (cursor <= nowMonth) {
            var hasPlay = !!playMonths[cursor]
            var curType = hasPlay ? 'played' : 'unplayed'

            if (curType === streakType) {
                streakLen++
            } else {
                if (streakType !== null) {
                    streaks.push({ type: streakType, months: streakLen, from: streakStart, to: cursor })
                }
                streakType = curType
                streakStart = cursor
                streakLen = 1
            }

            var parts = cursor.split('-')
            var y = parseInt(parts[0], 10)
            var m = parseInt(parts[1], 10) + 1
            if (m > 12) { m = 1; y++ }
            cursor = ('0000' + y).slice(-4) + '-' + ('0' + m).slice(-2)
        }

        if (streakType !== null) {
            streaks.push({ type: streakType, months: streakLen, from: streakStart, to: cursor })
        }

        // Build timeline and stats
        var timeline = []
        var totalMonths = 0
        var totalPlayed = 0
        var playedStreakLengths = []

        for (var si = 0; si < streaks.length; si++) {
            var s = streaks[si]

            var fromParts = s.from.split('-')
            s.fromLabel = monthNames[parseInt(fromParts[1], 10)] + ' ' + fromParts[0]

            var toParts = s.to.split('-')
            var ty = parseInt(toParts[0], 10)
            var tm = parseInt(toParts[1], 10) - 1
            if (tm < 1) { tm = 12; ty-- }
            s.toLabel = monthNames[tm] + ' ' + ty

            timeline.push({ type: s.type, months: s.months })
            totalMonths += s.months

            if (s.type === 'played') {
                totalPlayed += s.months
                playedStreakLengths.push(s.months)
            }
        }

        // Current, longest played, longest unplayed
        var current = streaks[streaks.length - 1]
        if (current) current.current = true

        var longestPlayed = null
        var longestUnplayed = null

        for (var li = 0; li < streaks.length; li++) {
            if (streaks[li].type === 'played' && (longestPlayed === null || streaks[li].months > longestPlayed.months)) longestPlayed = streaks[li]
            if (streaks[li].type === 'unplayed' && (longestUnplayed === null || streaks[li].months > longestUnplayed.months)) longestUnplayed = streaks[li]
        }

        // Clean from/to
        for (var ci = 0; ci < streaks.length; ci++) {
            delete streaks[ci].from
            delete streaks[ci].to
        }

        if (current) { delete current.from; delete current.to }
        if (longestPlayed) { delete longestPlayed.from; delete longestPlayed.to }
        if (longestUnplayed) { delete longestUnplayed.from; delete longestUnplayed.to }

        var averageHot = playedStreakLengths.length ? Math.round(playedStreakLengths.reduce(function(a, b) { return a + b }, 0) / playedStreakLengths.length * 10) / 10 : 0

        // Sort all by length for panel
        streaks.sort(function(a, b) { return b.months - a.months })

        return {
            current: current,
            longestPlayed: longestPlayed,
            longestUnplayed: longestUnplayed,
            totalPlayed: totalPlayed,
            totalMonths: totalMonths,
            averageHot: averageHot,
            timeline: timeline,
            streaks: streaks
        }

    }
})
